import React from 'react';
import { Modal} from 'react-bootstrap';
import dummyImage from '../../images/images.png'


const SocailMediaImages = ({ name, socialPostImage,  showImageDialog, setShowImageDialog}) => {

    const handleHide = () => {
        setShowImageDialog(false)
    }
  return (
    <Modal show={showImageDialog} onHide={() => handleHide()} centered>
      <Modal.Header className="dialog-header" closeButton>
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { (socialPostImage.length !== 0) ? socialPostImage.map((val) => {
            return ( <div className='image-grid'><img src={val} alt='' /></div> )}) : <div className='image-grid'> <img src={dummyImage} alt='' /> </div>}
      </Modal.Body>
    </Modal>
  );
};

export default SocailMediaImages;
